export const mobileConfigurationEndpoint = "api/configurations";
export const mobileConfigurationByIdEndpoint = (id: number) =>
  `${mobileConfigurationEndpoint}/${id}`;
export const zipEndpoint = (id: number) => `${mobileConfigurationEndpoint}/${id}/zip`;
export const userTypesEndpoint = "api/optionsCollections/usertype";
export const userGroupsEndpoint = "api/optionsCollections/usergroup";
